(function () {
  'use strict';

  var VISIBLE_CLASS = 'is-taupe-visible';
  var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');

  function mark(el, options) {
    if (!el || el.classList.contains('taupe-animate')) return;
    options = options || {};
    el.classList.add('taupe-animate');
    if (options.variant) el.classList.add('taupe-animate--' + options.variant);
    if (options.delay != null) {
      el.style.setProperty('--taupe-delay', options.delay * 0.09 + 's');
    }
  }

  function markAll(nodes, options) {
    Array.prototype.forEach.call(nodes, function (node, index) {
      var itemOptions = Object.assign({}, options || {}, { delay: index });
      mark(node, itemOptions);
    });
  }

  function sectionHead(wrapper) {
    wrapper.querySelectorAll('.taupe-lane-section-head > *').forEach(function (el, i) {
      mark(el, { delay: i });
    });
  }

  function configureSection(wrapper) {
    if (wrapper.getAttribute('data-taupe-configured') === 'true') return;
    wrapper.setAttribute('data-taupe-configured', 'true');
    wrapper.setAttribute('data-taupe-animate', '');

    var sectionClass = Array.prototype.find.call(wrapper.classList, function (cls) {
      return cls.indexOf('section-') === 0;
    });

    switch (sectionClass) {
      case 'section-taupe-lane-hero': {
        mark(wrapper.querySelector('.taupe-lane-hero__overlay'), { variant: 'fade' });
        markAll(wrapper.querySelectorAll('.taupe-lane-hero__inner > *'));
        wrapper.classList.add(VISIBLE_CLASS);
        break;
      }

      case 'section-taupe-trust-strip': {
        if (window.matchMedia('(min-width: 750px)').matches) {
          markAll(wrapper.querySelectorAll('.taupe-trust-strip__item'), { variant: 'fade' });
        }
        break;
      }

      case 'section-taupe-lane-story': {
        var storyMedia = wrapper.querySelector('.taupe-lane-story__media');
        if (window.matchMedia('(min-width: 990px)').matches) {
          mark(storyMedia, { variant: 'from-left' });
          mark(wrapper.querySelector('.taupe-lane-story__copy'), { variant: 'from-right', delay: 1 });
        } else {
          mark(storyMedia, { delay: 0 });
          mark(wrapper.querySelector('.taupe-lane-story__copy'), { delay: 1 });
        }
        markAll(wrapper.querySelectorAll('.taupe-lane-story__stat'));
        mark(wrapper.querySelector('.taupe-lane-story__btn'), { delay: 3 });
        break;
      }

      case 'section-taupe-how-it-works': {
        sectionHead(wrapper);
        markAll(wrapper.querySelectorAll('.taupe-how-it-works__step'), { variant: 'scale' });
        break;
      }

      case 'section-taupe-category-cards': {
        sectionHead(wrapper);
        markAll(wrapper.querySelectorAll('.taupe-category-cards__card'), { variant: 'scale' });
        break;
      }

      case 'section-featured-collection': {
        mark(wrapper.querySelector('.collection__title .title, .collection__title'), { delay: 0 });
        mark(wrapper.querySelector('.collection__description'), { delay: 1 });
        mark(wrapper.querySelector('.collection__view-all'), { delay: 2 });
        break;
      }

      case 'section-taupe-section-header': {
        sectionHead(wrapper);
        break;
      }

      case 'section-main-collection-product-grid': {
        mark(wrapper.querySelector('.collection'), { delay: 0 });
        break;
      }

      case 'section-taupe-sew-in-spotlight': {
        var spotlightMedia = wrapper.querySelector('.taupe-sew-in-spotlight__media');
        if (window.matchMedia('(min-width: 990px)').matches) {
          mark(spotlightMedia, { variant: 'from-left' });
          mark(wrapper.querySelector('.taupe-sew-in-spotlight__eyebrow'), { variant: 'from-right', delay: 1 });
          mark(wrapper.querySelector('.taupe-sew-in-spotlight__heading'), { variant: 'from-right', delay: 2 });
          mark(wrapper.querySelector('.taupe-sew-in-spotlight__text'), { variant: 'from-right', delay: 3 });
          mark(wrapper.querySelector('.taupe-sew-in-spotlight__actions'), { variant: 'from-right', delay: 4 });
        } else {
          mark(spotlightMedia, { delay: 0 });
          mark(wrapper.querySelector('.taupe-sew-in-spotlight__eyebrow'), { delay: 1 });
          mark(wrapper.querySelector('.taupe-sew-in-spotlight__heading'), { delay: 2 });
          mark(wrapper.querySelector('.taupe-sew-in-spotlight__text'), { delay: 3 });
          mark(wrapper.querySelector('.taupe-sew-in-spotlight__actions'), { delay: 4 });
        }
        break;
      }

      case 'section-taupe-social-proof': {
        sectionHead(wrapper);
        markAll(wrapper.querySelectorAll('.taupe-social-proof__stat'), { variant: 'fade' });
        markAll(wrapper.querySelectorAll('.taupe-social-proof__card'), { variant: 'scale' });
        break;
      }

      case 'section-taupe-silk-press-spotlight': {
        var silkMedia = wrapper.querySelector('.taupe-silk-press-spotlight__media');
        if (window.matchMedia('(min-width: 990px)').matches) {
          mark(silkMedia, { variant: 'from-left' });
          mark(wrapper.querySelector('.taupe-silk-press-spotlight__eyebrow'), { variant: 'from-right', delay: 1 });
          mark(wrapper.querySelector('.taupe-silk-press-spotlight__heading'), { variant: 'from-right', delay: 2 });
          mark(wrapper.querySelector('.taupe-silk-press-spotlight__text'), { variant: 'from-right', delay: 3 });
          mark(wrapper.querySelector('.taupe-silk-press-spotlight__actions'), { variant: 'from-right', delay: 4 });
        } else {
          mark(silkMedia, { delay: 0 });
          mark(wrapper.querySelector('.taupe-silk-press-spotlight__eyebrow'), { delay: 1 });
          mark(wrapper.querySelector('.taupe-silk-press-spotlight__heading'), { delay: 2 });
          mark(wrapper.querySelector('.taupe-silk-press-spotlight__text'), { delay: 3 });
          mark(wrapper.querySelector('.taupe-silk-press-spotlight__actions'), { delay: 4 });
        }
        break;
      }

      case 'section-taupe-lane-cta':
        break;

      case 'section-taupe-faq': {
        sectionHead(wrapper);
        markAll(wrapper.querySelectorAll('.taupe-faq__item'));
        mark(wrapper.querySelector('.taupe-faq__cta-wrap'), { delay: 2 });
        break;
      }

      default:
        break;
    }
  }

  function isTaupeLanePage() {
    return (
      document.body.classList.contains('taupe-lane-page') ||
      document.body.classList.contains('taupe-hair-page') ||
      document.body.classList.contains('taupe-tools-page')
    );
  }

  function observeSections() {
    if (!isTaupeLanePage()) return;

    var sections = document.querySelectorAll('#MainContent .shopify-section');
    if (!sections.length) return;

    if (REDUCED_MOTION.matches) {
      sections.forEach(function (wrapper) {
        configureSection(wrapper);
        wrapper.classList.add(VISIBLE_CLASS);
      });
      return;
    }

    sections.forEach(configureSection);

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add(VISIBLE_CLASS);
          observer.unobserve(entry.target);
        });
      },
      {
        root: null,
        rootMargin: '0px 0px -8% 0px',
        threshold: 0.12,
      }
    );

    sections.forEach(function (wrapper) {
      if (wrapper.classList.contains('section-taupe-lane-hero')) return;
      observer.observe(wrapper);
    });
  }

  function init() {
    observeSections();
    if (typeof initializeScrollAnimationTrigger === 'function') {
      initializeScrollAnimationTrigger();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!isTaupeLanePage()) return;
    var wrapper = event.target;
    if (!wrapper.classList.contains('shopify-section')) {
      wrapper = event.target.querySelector('.shopify-section') || event.target;
    }
    configureSection(wrapper);
    if (!REDUCED_MOTION.matches && !wrapper.classList.contains('section-taupe-lane-hero')) {
      var observer = new IntersectionObserver(
        function (entries, obs) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add(VISIBLE_CLASS);
            obs.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
      );
      observer.observe(wrapper);
    } else {
      wrapper.classList.add(VISIBLE_CLASS);
    }
    if (typeof initializeScrollAnimationTrigger === 'function') {
      initializeScrollAnimationTrigger(event.target, true);
    }
  });
})();
